export const comments_3787342 = {"data":{"data":[],"links":{}}}